import {
  Alert,
  Column,
  Columns,
  Divider,
  Placeholder,
  Stack,
  Tab,
  Tabs,
  TextLink,
  Text,
} from "@origin-digital/ods-core";
import * as React from "react";
import { FormValues } from "./types";
import { useFormikContext } from "formik";
import FormContext from "src/context/FormContext";
import RequestorInfo from "./RequestorInfo";
import { format } from "date-fns";
import { isUnavailableDateForFuture } from "./helper";
import { apiClient } from "src/api/apiService";

const ReadOnlyInternetBlock = () => {
  const { values } = useFormikContext<FormValues>();
  const { formState } = React.useContext(FormContext);
  const { setDisplayingSnackbar } = React.useContext(FormContext);

  const handleResend = async () => {
    try {
      const resendRes = await apiClient.post(
        "/internet/customer-communication",
        {
          premise_id: values.id,
          request_id_being_lodged: formState.internetService?.requestId,
        }
      );
      if (resendRes.status === 200) {
        // Show success snackbar
        setDisplayingSnackbar({
          message: "Notification re-sent.",
          tone: "positive",
        });
      } else {
        setDisplayingSnackbar({
          message: "Failed to re-send notification.",
          tone: "caution",
        });
      }
    } catch (error) {
      setDisplayingSnackbar({
        message: "Failed to re-send notification.",
        tone: "caution",
      });
    }
  };

  const commSentDateTime = formState.internetService?.commSentDateTime
    ? format(
        new Date(formState.internetService?.commSentDateTime),
        "dd/MM/yyyy"
      )
    : "";

  const handoverDate = formState.internetService?.handoverDate
    ? format(new Date(formState.internetService?.handoverDate), "dd/MM/yyyy")
    : "";

  const showNotice = !(formState.internetService?.handoverDate
    ? isUnavailableDateForFuture(
        new Date(formState.internetService?.handoverDate)
      )
    : true);
  return (
    <>
      <Tabs defaultValue={0} id="internet-tab">
        <Tab data-id="tab1" label="Request">
          <Stack
            space={{
              xs: "xlarge",
              md: "xxlarge",
            }}
          >
            <Stack
              space={{
                xs: "xlarge",
                md: "xlarge",
              }}
            >
              {showNotice && (
                <Columns
                  collapseBelow="md"
                  space={{
                    xs: "none",
                    md: "xlarge",
                  }}
                  alignY="stretch"
                >
                  <Column width="2/3">
                    <Alert>
                      <Text>
                        Email about our Internet plans sent to account holder on{" "}
                        {commSentDateTime}.{" "}
                        <TextLink href="#internet-tab" onClick={handleResend}>
                          Resend?
                        </TextLink>
                      </Text>
                    </Alert>
                  </Column>
                  <Column width="1/3" />
                </Columns>
              )}
              <Columns
                collapseBelow="md"
                space={{
                  xs: "none",
                  md: "xlarge",
                }}
                alignY="stretch"
              >
                <Column width="2/3">
                  <Stack space="xsmall">
                    <Stack space="xxsmall">
                      <Text variant="body-small" tone="neutralLight">
                        LOC ID
                      </Text>
                      <Text>{values.locId}</Text>
                    </Stack>
                    <Divider />
                  </Stack>
                </Column>
                <Column width="1/3" />
              </Columns>
              <Columns
                collapseBelow="md"
                space={{
                  xs: "none",
                  md: "xlarge",
                }}
                alignY="stretch"
              >
                <Column width="2/3">
                  <Stack space="xsmall">
                    <Stack space="xxsmall">
                      <Text variant="body-small" tone="neutralLight">
                        Handover date
                      </Text>
                      <Text>{handoverDate}</Text>
                    </Stack>
                    <Divider />
                  </Stack>
                </Column>
                <Column width="1/3" />
              </Columns>
            </Stack>
            <RequestorInfo
              requesterName={values.internetRequesterName || " "}
              submittedDateTime={values.internetSubmittedDateTime || ""}
            />
          </Stack>
        </Tab>
        <Tab data-id="tab2" label="Messages">
          <Placeholder height={600} label="Messages" />
        </Tab>
      </Tabs>
      {/* <Snackbar open tone="positive" align="left" showClose autoHideDuration={5000}>
  Notification re-sent.
</Snackbar> */}
    </>
  );
};

export default ReadOnlyInternetBlock;
